
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prizes/search",
      function () {
        return require("private-next-pages/prizes/search/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prizes/search"])
      });
    }
  